/* eslint-disable prefer-destructuring */
import Url from 'url-parse';
import { Modal } from 'bootstrap';

class LeavingSite {
  constructor() {
    const domModal = document.getElementById('leavingSite');
    this.modal = new Modal(domModal);
    this.domModalExternalLink = domModal.getElementsByClassName('hrexternal')[0];
    this.domModalContinue = domModal.getElementsByClassName('leavingSiteContinue')[0];
    this.domModalContinue.addEventListener('click', (event) => { this.continueButtonClicked(); });
    

    const domEmailModal = document.getElementById('leavingSiteEmail');
    this.modalEmail = new Modal(domEmailModal);
    this.domModalEmailExternalLink = domModal.getElementsByClassName('hrexternal')[0];
    this.domModalEmailContinue = domEmailModal.getElementsByClassName('leavingSiteContinue')[0];
    this.domModalEmailContinue.addEventListener('click', (event) => { this.continueButtonEmailClicked(); });
    

    const currentSiteHostname = document.location.hostname.trim().toLowerCase();
    const links = document.querySelectorAll('a');

    for (let i = 0; i < links.length; i++) {
      if (links[i] != null && !links[i].hasAttribute('data-ignore-leaving-site')) {

        const link = Url(links[i]);
        if (link != null && link.hostname != null && link.hostname !== '') {
          const cleanLinkHostname = link.hostname.trim().toLowerCase();
          if (cleanLinkHostname !== currentSiteHostname) {
            let ignore = false;
            for (const j in window.SpeedBumpAllow) {
              const allow = window.SpeedBumpAllow[j];
              const allowUrl = Url('http://' + allow);

              if (allow !== null && allow.trim().toLowerCase() === cleanLinkHostname) {
                ignore = true;
                break;
              }

              if (allowUrl !== null && allowUrl.hostname.trim().toLowerCase() === cleanLinkHostname) {
                ignore = true;
                break;
              }
            }

            if (!ignore) {
              links[i].addEventListener('click', (event) => { event.preventDefault(); this.externalLinkClicked(links[i]); });
            }
          }
        } else if (link != null && link.protocol != null && link.protocol.toLowerCase() === 'mailto:') {
          let ignore = false;
          for (const j in window.SpeedBumpAllow) {
            const allow = window.SpeedBumpAllow[j];

            if (allow !== null && allow.trim().toLowerCase() === link.href.toLowerCase()) {
              ignore = true;
              break;
            }
          }

          if (!ignore) {
            links[i].addEventListener('click', (event) => { event.preventDefault(); this.externalEmailLinkClicked(links[i]); });
          }
        }

      }

    }
  }

  externalLinkClicked(link) {
    this.domModalContinue.href = link.href;
    this.domModalContinue.target = link.target;
    this.domModalExternalLink.innerHTML = link.href;
    this.modal.show();
  }

  externalEmailLinkClicked(link) {
    this.domModalEmailContinue.href = link.href;
    this.domModalEmailContinue.target = link.target;
    this.domModalEmailExternalLink.innerHTML = link.href;
    this.modalEmail.show();
  }

  continueButtonClicked() {
    this.modal.hide();
  }

  continueButtonEmailClicked() {
    this.modalEmail.hide();
  }
}

new LeavingSite();
